/**
 * @generated SignedSource<<51d803781f4169f0b49f1ee8d5a2bf18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReAssignModal_getTicketQuery$variables = {
  id: string;
};
export type ReAssignModal_getTicketQuery$data = {
  readonly getTicket: {
    readonly assignTo: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly id: string;
    readonly scheduleEndDate: any | null;
    readonly scheduleStartDate: any | null;
    readonly uuid: string | null;
  };
};
export type ReAssignModal_getTicketQuery = {
  response: ReAssignModal_getTicketQuery$data;
  variables: ReAssignModal_getTicketQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TicketObjectType",
    "kind": "LinkedField",
    "name": "getTicket",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "assignTo",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleStartDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleEndDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReAssignModal_getTicketQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReAssignModal_getTicketQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7f442e208d537b686306207d4e5c2fc9",
    "id": null,
    "metadata": {},
    "name": "ReAssignModal_getTicketQuery",
    "operationKind": "query",
    "text": "query ReAssignModal_getTicketQuery(\n  $id: String!\n) {\n  getTicket(id: $id) {\n    id\n    uuid\n    assignTo {\n      id\n      firstName\n    }\n    scheduleStartDate\n    scheduleEndDate\n  }\n}\n"
  }
};
})();

(node as any).hash = "be01f60b6689bb1320b54a874298adec";

export default node;
